import { EXPORT_READ_API_PREFIX } from '@aibees/elephant/constants';
import { useBrowseSearchExports } from '@aibees/elephant/hooks/use-browse-search-exports';
import { HttpMethod } from '@aibees/shared/definition';
import { baseQueryClient, useBaseMutation } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';
import { RetryIntegrationRequest } from './types';

export function useRetryIntegrationApi(id: string) {
  const workspaceId = useWorkspace()?.id ?? '';

  return useBaseMutation<RetryIntegrationRequest, unknown>(
    {
      url: `${EXPORT_READ_API_PREFIX.replace(':wid', workspaceId).replace(
        ':id',
        id
      )}`,
      method: HttpMethod.post,
      params: {
        action: 'retry-integration',
      },
    },
    {
      onSuccess: () => {
        baseQueryClient.invalidateQueries([useBrowseSearchExports.name]);
      },
    }
  );
}
